import { css } from 'styled-components/macro';

export const flex: any = css`
	display: flex;
`;

export const row: any = css`
	${flex}
	flex-direction: row;
`;

export const column: any = css`
	${flex}
	flex-direction: column;
`;

export const center: any = css`
	align-items: center;
	justify-content: center;
`;

export const row_between: any = css`
	${row}
	justify-content: space-between;
`;

export const row_center_horizontal: any = css`
	${row}
	justify-content: center;
`;

export const row_center_vertical: any = css`
	${row}
	align-items: center;
`;

export const row_center_both: any = css`
	${row}
	${center}
`;

export const row_center_start: any = css`
	${row_center_vertical}
	justify-content: flex-start;
`;

export const row_center_vertical_start: any = css`
	${row_center_vertical}
	align-items: flex-start;
`;

export const row_center_end: any = css`
	${row_center_vertical}
	justify-content: flex-end;
`;

export const row_center_between: any = css`
	${row_center_vertical}
	justify-content: space-between;
`;

export const column_center_both: any = css`
	${column}
	${center}
`;

export const column_between: any = css`
	${column}
	justify-content: space-between;
`;

export const column_center_vertical: any = css`
	${column}
	justify-content: center;
`;

export const column_center_horizontal: any = css`
	${column}
	align-items: center;
`;

export const link: any = css`
	cursor: pointer;
	text-decoration: underline !important;
`;

export const ellipse: any = css`
	display: flex;
	align-items: center;
`;
